import React, { useState, useEffect, Fragment } from "react";

const UsereviewRatingTable = (
    emptypeData,
    handleDelReview,
    handleEditReview,
    onClickToggleFromTable
) => {
  const [thead] = useState(["Review", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = emptypeData.map((el) => {
      return {
        "Review": el.rating,
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4"              
              onClick={() => {
                handleEditReview(el, el.reviewId);
                onClickToggleFromTable();
             }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelReview(el.ratingId)}
            ></i>
            
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    emptypeData,
    handleDelReview,
    handleEditReview,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default UsereviewRatingTable;